import { Component } from 'react';
import PropTypes from 'prop-types';


class Trigger extends Component {
  static getDomId() {
    return 'error_trigger';
  }

  static getComponentData() {
    return window.seMarketplace.error_trigger;
  }

  componentDidMount() {
    const { headline, message } = this.props;

    setTimeout(() => {
      window.emitMarketplaceEvent(
        'showUserErrorMessage',
        { headline, message },
      );
    });
  }

  render() {
    return null;
  }
}

Trigger.propTypes = {
  headline: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default Trigger;
